<style>
  .login_header {
    height: 64px;
    line-height: 64px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .login_hl span {
    font-size: 18px;
    color: #848484;
    border-left: 2px solid #b0b0b0;
    height: 29px;
    line-height: 29px;
    padding-left: 20px;
    margin-top: 20px;
    letter-spacing: 1px;
  }

  .login_hl {
    display: flex;
    width: 267px;
    justify-content: space-between;
  }

  .login_hr {
    position: relative;
    font-size: 18px;
    color: #999999;
  }

  .login_hr i {
    position: absolute;
    top: 0;
    left: -50px;
    display: block;
    width: 64px;
    height: 64px;
    background: url("//official.cdn.qiyewan.com/login_phone.png") no-repeat center;
  }

  .reset_con {
    margin-top: 9px;
  }
  .reset_con .form {
    margin-left: 30%;
    margin-right: 30%;
    min-width: 300px;
    margin-top: 30px;
  }
  .register_con .confirm-button{
    margin-left: 120px;
    box-sizing: border-box;
    width: 344px;
  }
</style>
<template>
  <div style="background-color:#f3f3f3;">
    <div class="login_header">
      <div class="container flex">
        <div class="login_hl">

          <router-link
            :to="{ path: '/'}">
            <img style="height: 44px; margin-top: 10px;cursor: pointer"
                 src="//official.cdn.qiyewan.com/logo.png" alt="">
          </router-link>
          <span>找回密码</span>
        </div>
      </div>
    </div>
    <div class="reset_con">
      <div class="container" style="height: 510px;background-color:#fff;">
        <el-form ref="registerForm"
                 :rules="rules"
                 :model="form"
                 label-width="120"
                 lebel-position="left"
                 class="form"
                 style="padding-top:88px;">
          <el-form-item prop="phone"
                        label="手机号/用户名"
                        label-width="120px">
            <el-input v-model="form.phone" placeholder="">
            </el-input>
          </el-form-item>
          <el-form-item label="输入验证码"
                        prop="captcha"
                        label-width="120px">
            <el-input type="text"
                      v-model="form.captcha"
                      placeholder=""
                      style="width: 73%;">
            </el-input>
            <el-button type="primary"
                       :disabled="isWaiting"
                       @click="requestCaptcha"
                       style="background: #007fff;border-radius: 1px;border: none;color: white; height: 45px;">
              {{ isWaiting ? timerShow : "点击获取" }}
            </el-button>
          </el-form-item>
          <el-form-item prop="password"
                        label="输入新密码"
                        label-width="120px">
            <el-input type="password"
                      v-model="form.password"
                      placeholder="">
            </el-input>
          </el-form-item>
          <el-form-item prop="password2"
                        label="确认新密码"
                        label-width="120px">
            <el-input type="password"
                      v-model="form.password2"
                      placeholder="">
            </el-input>
          </el-form-item>

          <el-button type="primary"
                     @click.native="submit"
                     :loading="isSubmitting"
                     class="confirm-button">
            {{ isSubmitting ? "提交中" : "提  交" }}
          </el-button>
        </el-form>
      </div>
    </div>
    <zj-footer/>
  </div>
</template>

<script>
  export default {
    data () {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      }
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请重复输入密码'));
        } else {
          if (this.form.password !== this.form.password2) {
            callback(new Error('两次输入的密码不相符'))
          }
          callback();
        }
      }
      return {
        checked: false,
        form: {
          phone: '',
          password: '',
          password2: '',
          captcha: ''
        },
        timer: 60,
        isWaiting: false,
        isSubmitting: false,
        rules: {
          phone: [
            {
              required: true,
              message: '请输入手机号',
              trigger: 'blur'
            }
          ],
          captcha: [
            {
              required: true,
              message: '请输入验证码',
              trigger: 'blur'
            }
          ],
          password: [
            {
              required: true,
              validator: validatePass,
              trigger: 'blur'
            }
          ],
          password2: [
            {
              required: true,
              validator: validatePass2,
              trigger: 'blur'
            }
          ]
        }
      }
    },
    computed: {
      timerShow () {
        return `${this.timer}秒`
      }
    },
    methods: {
      requestCaptcha () {
        let vm = this
        if (vm.form.phone === undefined || vm.form.phone === '') {
          vm.$message.warning('手机号不能为空')
          return false
        }
        vm.$store.dispatch('isRegistered', vm.form.phone).then(
          data => {
            if (data.registered) {
              vm.$store.dispatch('requestCaptcha', vm.form.phone)
              vm.isWaiting = true
              vm.timer = 60
              vm.counterDown()
              return false
            } else {
              vm.$message.error('手机号未注册')
              return false
            }
          }
        )
      },
      counterDown () {
        setTimeout(() => {
          if (this.timer === 0) {
            this.isWaiting = false
            return true
          }
          this.timer -= 1
          this.counterDown()
        }, 1000)
      },
      submit () {
        let vm = this
        vm.$refs.registerForm.validate(function (valid) {
          if (valid) {
            vm.isSubmitting = true
            vm.$store.dispatch('userResetPassword', {
              phone: vm.form.phone,
              password: vm.form.password,
              captcha: vm.form.captcha
            }).then(() => {
              vm.isVisible = false
              vm.isSubmitting = false
              vm.$message.success('修改成功')
            }, (error) => {
              vm.isSubmitting = false
              vm.$message.error(error.message)
            })
            vm.$router.push({path: '/'})
          } else {
            return false
          }
        })
      }
    },
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?51a7810a